module.exports = __webpack_public_path__ + "img/TCFD.d0a9f91c.png";